<template>
  <div class="mcq">
    <label class="mcq-label" :for="inputId">Otra cantidad de {{ itemName }}</label>
    <input
      :id="inputId"
      ref="input"
      :value="value"
      class="mcq-input"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      autocomplete="off"
      placeholder="Cantidad"
      :maxlength="maxDigits"
      @input="typeDigits"
    />
    <span class="mcq-unit" aria-hidden="true">{{ unit }}</span>
    <button
      type="button"
      class="mcq-clear"
      :aria-label="`Quitar la cantidad de ${itemName}`"
      @click="$emit('clear')"
    >&times;</button>
  </div>
</template>

<script>
import { QUANTITY_UNIT, onlyDigits } from './materialsOrderSelection';

const INPUT_ID_PREFIX = 'materials-order-custom-';

export default {
  name: 'MaterialsOrderCustomQuantity',
  props: {
    value: { type: String, default: '' },
    materialId: { type: [Number, String], required: true },
    itemName: { type: String, required: true },
    maxDigits: { type: Number, required: true },
    unit: { type: String, default: QUANTITY_UNIT },
  },
  computed: {
    inputId() {
      return `${INPUT_ID_PREFIX}${this.materialId}`;
    },
  },
  methods: {
    typeDigits(event) {
      const digits = onlyDigits(event.target.value);
      event.target.value = digits;
      this.$emit('input', digits);
    },
    focus() {
      this.$refs.input.focus();
      this.$refs.input.select();
    },
  },
};
</script>

<style scoped>
.mcq {
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  border: 1.5px solid #01662E;
  border-radius: 14px;
  background: #fff;
  padding: 0 3px 0 12px;
}
.mcq:focus-within { box-shadow: 0 0 0 3px rgba(1, 102, 46, 0.18); }
.mcq-label {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.mcq-input {
  flex: 1 1 auto;
  width: 0;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  font-family: inherit;
}
.mcq-input::placeholder { color: #6b7280; font-weight: 400; }
.mcq-unit {
  margin: 0 6px;
  font-size: 12.5px;
  color: #4b5563;
}
.mcq-clear {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: #eef1ef;
  color: #374151;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
}
.mcq-clear:hover { background: #e2e6e3; }
.mcq-clear:focus-visible {
  outline: 2px solid #01662E;
  outline-offset: 1px;
}
</style>
